export const setAssignments = (assignments) => {
    return {
        type: "SET_ASSIGNMENTS",
        payload: assignments
    }
};
